enum FormSpecKey {
  PEXBD_V1_GROUP1 = 'pexbd-v1-group1',
  PEXBD_V1_GROUP2 = 'pexbd-v1-group2',
  PEXBD_V2 = 'pexbd-v2',
  PEXBD_V3 = 'pexbd-v3',
}

export const resolveFormSpecKey = (formData: { specKey?: string }): FormSpecKey | null => {
  if (formData.specKey && Object.values(FormSpecKey).includes(formData.specKey as FormSpecKey)) {
    return formData.specKey as FormSpecKey;
  }
  return null;
};

export default FormSpecKey;
